import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { InfoResponse } from "kz-ui-sdk";

export interface PreferenceSliceState {
  serverInfo: InfoResponse | null;
  displayAppInstaller: boolean;
  isLoading: boolean;
}

const initialState: PreferenceSliceState = {
  serverInfo: null,
  displayAppInstaller: false,
  isLoading: true,
};

const preferenceSlice = createSlice({
  name: "@preference",
  initialState,
  reducers: {
    setServerInfo(state, action: PayloadAction<InfoResponse>) {
      state.serverInfo = action.payload;
      if (action.payload) {
        state.isLoading = false;
      }
    },
    setDisplayAppInstaller(state, action: PayloadAction<boolean>) {
      state.displayAppInstaller = action.payload;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export default preferenceSlice;
